export const site = {
  name: 'A.M. Home Care, Inc.',
  shortName: 'A.M. Home Care',
  tagline: {
    en: 'Specializing in unique and loving care for you and your loved one',
    es: 'Especializados en un cuidado único y amoroso para ti y tu ser querido',
  },
  phoneDisplay: '(703) 231-7468',
  phoneIntl: '+1 (703) 231-7468',
  tel: 'tel:+17032317468',
  whatsapp: 'https://wa.me/17032317468',
  email: 'a.m.homecare.virginia@gmail.com',
  mailto: 'mailto:a.m.homecare.virginia@gmail.com',
  website: 'https://amhomecareva.com',
  address: {
    street: '3134 Eagle Talon St',
    city: 'Woodbridge',
    region: 'VA',
    postalCode: '22191',
  },
  mapsUrl: 'https://www.google.com/maps/search/?api=1&query=3134+Eagle+Talon+St,+Woodbridge,+VA+22191',
  social: {
    facebook: 'https://www.facebook.com/',
    instagram: 'https://www.instagram.com/',
    linkedin: 'https://www.linkedin.com/',
  },
  googleReviewsUrl: 'https://www.google.com/search?q=A.M.+Home+Care+Inc+Woodbridge+VA+reviews',
  mapEmbedUrl:
    'https://www.google.com/maps?q=3134+Eagle+Talon+St,+Woodbridge,+VA+22191&z=9&output=embed',
  rating: 5.0,
  reviewCount: 3,
}

export const serviceCities = [
  'Woodbridge',
  'Fairfax',
  'Arlington',
  'Alexandria',
  'Falls Church',
  'Leesburg',
]

export const serviceCounties = [
  { en: 'Prince William County', es: 'Condado de Prince William' },
  { en: 'Fairfax County', es: 'Condado de Fairfax' },
  { en: 'Arlington County', es: 'Condado de Arlington' },
  { en: 'Loudoun County', es: 'Condado de Loudoun' },
  { en: 'City of Alexandria', es: 'Ciudad de Alexandria' },
]
